import { useDialog } from "src/components/Modalservice/Dialogservice";
import React from "react";
import { useI18n } from "src/utils/lni18n";
import { AlertDialog, AlertOptions } from "./AlertDialog";


export const useAlert = () => {
    const dialogPortal = useDialog();
    const { languageService: t } = useI18n();

    function alert(size: "md" | "sm" | "xl" | "lg" | "recorder" | undefined, title: string, message: string | React.ReactNode) {

        return dialogPortal({
            factory: (onSubmit, _) => {
                const dprops: AlertOptions = {
                    title: title,
                    message: message,
                    languageService: t,
                    onSubmit: onSubmit,
                    className: ""
                }
                return <AlertDialog {...dprops} />
            },
            size: size
        }).catch((e: Error) => {
            console.error("Alert dialog error: ", e);
         });

    }

    return alert;

}